<script lang="ts" setup>
const route = useRoute()
const { replace } = useRouter()
const ID = ref<DialogID | ''>('')

export type DialogID = 'sell-workflow' | 'knowledge-base' | 'buy-workflow'

const dialogs: Record<DialogID, Component> = {
  'sell-workflow': defineAsyncComponent(() => import('./SellWorkflowsDialog.vue')),
  'knowledge-base': defineAsyncComponent(() => import('./KnowledgeBaseDialog.vue')),
  'buy-workflow': defineAsyncComponent(() => import('./BuyWorkflowsDialog.vue')),
}

// onBeforeMount(() => {
//   if (query?.dial_id !== ID.value)
//     ID.value = Array.isArray(query?.dial_id) ? query?.dial_id.join('') : query?.dial_id ?? ''
// })

const closeModal = (event: boolean) => {
  if (event)
    return

  ID.value = ''
}

watch(ID, (value) => {
  if (route.query.dial_id !== ID.value) {
    replace({
      query: {
        ...route.query,
        dial_id: value ? ID.value : undefined,
      },
    })
  }
})

watch(() => route.query, (newQuery) => {
  if (newQuery?.dial_id !== ID.value)
    ID.value = Array.isArray(newQuery?.dial_id) ? newQuery?.dial_id.join('') as DialogID : (newQuery?.dial_id ?? null) as DialogID
}, { immediate: true, deep: true })
</script>

<template>
  <ClientOnly>
    <Transition v-if="ID" key="dialog" name="fade">
      <component
        :is="dialogs[ID]" @update:open="($event: boolean) => {
          closeModal($event)
        }"
      />
    </Transition>
  </ClientOnly>
</template>
